export default __webpack_public_path__ + "static/media/photo--lg--103.f398506e.jpg";